import { EscopoCartaoView } from "./view-escopo-cartao";
import type { EscopoCartaoProps } from "./types-escopo-cartao";

export function EscopoCartao(props: EscopoCartaoProps) {
  return <EscopoCartaoView {...props} />;
}

export type * from "./types-escopo-cartao";
